import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CustomEase } from '../gsap-club/gsap-business-green/src/CustomEase';
gsap.registerPlugin( ScrollTrigger, CustomEase );

/* eslint-disable */
( function () {
	const customVideo = document.querySelector( '.custom-video' );

	if ( customVideo ) {
		const tl = gsap.timeline( { paused: true } );
		const video = customVideo.querySelectorAll( '.custom-video__wrap' );

		video.forEach( (item) => {

			tl.from(item, {
				scale: 0.875,
				duration: 0.3,
				ease: 'power3.out',
				onComplete: () => {
					const allTriggers = ScrollTrigger.getAll();

					// Loop through all triggers and refresh each one
					allTriggers.forEach(trigger => {
						trigger.refresh();
					});
				}
			}, 0);
		} );


		// create the ScrollTrigger instance
		const trigger = ScrollTrigger.create( {
			animation: tl,
			trigger: customVideo,
			start: 'top bottom-=25%',
			end: "center center",
			scrub: 0.25
		} );
	}
} )();
/* eslint-enable */
